<div class="card">
    <div class="card-body">
        <ejs-grid #grid [dataSource]='data' [query]='query' height="60vh" [editSettings]="editSettings" [toolbar]="toolbar"
            [columns]='columns' (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'>
            <ng-template #col0Template let-data>
                <div class="row text-wrap">
                    <span>
                         {{ data.RelatedTypeId == relatedConditions?.[0]?.relatedTypeId ? "" : "**" }}
                        @if (canPreview(data)) {
                            <i (click)="previewFile(data)" class="fas fa-eye me-2"></i>
                        }
                        <i (click)="downloadFile(data)" class="fas fa-download"></i>
                    </span>
                </div>
            </ng-template>
            <ng-template #col1Template let-data>
                <div class="row text-wrap">
                    <span><strong>{{data.FileName}}</strong></span>
                    <span>size : {{data.Size}}</span>
                </div>
            </ng-template>
            <ng-template #col2Template let-data>
                <div class="row text-wrap">
                    <span><Strong>{{data.CreatedBy.FirstName}}</Strong></span>
                    <span><app-get-date-time [dateTime]="data.CreatedOn"></app-get-date-time></span>
                </div>
            </ng-template>
            <ng-template #editSettingsTemplate let-data>
                <div [formGroup]="formData">
                    <div class="row ">
                        <div class="form-group col-lg-12 col-sm-12">
                            <div class="e-float-input e-control-wrapper"
                                [ngClass]="{'e-error': f.Name.invalid && submitClicked}">
                                <input formControlName="Name" data-msg-containerid='NameError' id="Name" name="Name"
                                    type="text" autocomplete="off">
                                <span class="e-float-line"></span>
                                <label class="e-float-text e-label-top" for="Name">Name</label>
                            </div>
                            <div id="NameError" [style.visibility]='( 
                            (f.Name.invalid && submitClicked))? "visible": "hidden"'>
                                <label class="e-error" for="Name" id="Name-info" style="display: block;">
                                    *Name can not be empty</label>
                            </div>
                        </div>
                        <div class="form-group col-lg-12">
                            <input type="file" (change)="onFileSelected($event)">
                        </div>
                        <div *ngIf="isUploading">
                            <progressbar [value]="uploadProgress"></progressbar>
                        </div>
                        <div class="form-group col-lg-4 col-sm-12">
                            <div class="e-float-input e-control-wrapper"
                                [ngClass]="{'e-error': f.FileName.invalid && submitClicked}">
                                <input formControlName="FileName" data-msg-containerid='FileNameError' readonly id="FileName"
                                    name="FileName" type="text" autocomplete="off">
                                <span class="e-float-line"></span>
                                <label class="e-float-text e-label-top" for="FileName">File Name </label>
                            </div>
                            <div id="FileNameError" [style.visibility]='( 
                            (f.FileName.invalid && submitClicked))? "visible": "hidden"'>
                                <label class="e-error" for="FileName" id="FileName-info" style="display: block;">
                                    *File Name can not be empty</label>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-sm-12">
                            <div class="e-float-input e-control-wrapper"
                                [ngClass]="{'e-error': f.Size.invalid && submitClicked}">
                                <input formControlName="Size" data-msg-containerid='SizeError' readonly id="Size" name="Size"
                                    type="text" autocomplete="off">
                                <span class="e-float-line"></span>
                                <label class="e-float-text e-label-top" for="Size">Size</label>
                            </div>
                            <div id="SizeError" [style.visibility]='( 
                            (f.Size.invalid && submitClicked))? "visible": "hidden"'>
                                <label class="e-error" for="Size" id="Size-info" style="display: block;">
                                    *File Name can not be empty</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-grid>
    </div>
</div>

<app-image-preview
    [(visible)]="previewImageVisible"
    [title]="previewTitle"
    [imageUrl]="previewImageUrl"
    (closed)="onPreviewClose()">
</app-image-preview>

<app-pdf-preview
    [(visible)]="previewPdfVisible"
    [title]="previewTitle"
    [pdfBytes]="previewPdfBytes"
    (closed)="onPdfPreviewClosed()">
</app-pdf-preview>

<ejs-toast #defaulttoast [position]="position" >
    <ng-template #content>
        <div class="text-danger">{{actionFailedError}}</div>
    </ng-template>
    <ng-template #title>
        <div class="text-danger">Error</div>
    </ng-template>
</ejs-toast>
